var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.66669 14H3.33335C2.97973 14 2.64059 13.8595 2.39054 13.6095C2.14048 13.3594 2.00002 13.0203 2.00002 12.6667V8.66667C2.00002 8.31304 2.14048 7.97391 2.39054 7.72386C2.64059 7.47381 2.97973 7.33333 3.33335 7.33333H4.66669M9.33335 6V3.33333C9.33335 2.97971 9.19288 2.64057 8.94283 2.39052C8.69278 2.14048 8.35364 2 8.00002 2L5.33335 7.33333V14H11.7867C12.1095 14.0037 12.4228 13.8905 12.6685 13.6813C12.9143 13.4721 13.0757 13.181 13.1234 12.8627L14.0467 6.86267C14.0754 6.66876 14.0623 6.47058 14.0084 6.28236C13.9544 6.09413 13.8609 5.92044 13.7346 5.77384C13.6082 5.62724 13.4522 5.51143 13.2776 5.43466C13.1031 5.35789 12.9145 5.32209 12.7253 5.32967H9.33335Z",
    stroke: "#1E5AD2",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.1aa77c7465d1ec99486b1bd7bd41b51f.svg";
export { ForwardRef as ReactComponent };